var map = {
	"./1.jpg": 79212,
	"./2.jpg": 22011,
	"./4.jpg": 61701,
	"./5.jpg": 99336,
	"./6.jpg": 33559,
	"./7.jpg": 39098,
	"./ALL ANIMALS.jpg": 51359,
	"./BIRD.jpg": 69352,
	"./BOY 1.jpg": 96378,
	"./BOY 9.jpg": 19506,
	"./RABBIT 4 NEW.jpg": 99859,
	"./angry bird.jpg": 3653,
	"./apple &banana.jpg": 44480,
	"./apple.jpg": 66041,
	"./bird 10.jpg": 34465,
	"./bird 3.jpg": 44063,
	"./bird 4.jpg": 23252,
	"./bird 7.jpg": 1379,
	"./bird 8.jpg": 37880,
	"./birds with girl.jpg": 64115,
	"./boy 01.jpg": 82170,
	"./boy 02.jpg": 4773,
	"./boy 7.jpg": 23372,
	"./boy.jpg": 31527,
	"./butter fly & rabbit.jpg": 49028,
	"./butter flys.jpg": 39013,
	"./cycle.jpg": 49151,
	"./dol.jpg": 18748,
	"./dolphin 1.jpg": 57520,
	"./duck 1.jpg": 46547,
	"./elephant 4.jpg": 92482,
	"./elephant 6.jpg": 69840,
	"./fish 1.jpg": 96554,
	"./fish 2-Recovered.jpg": 64541,
	"./fox.jpg": 84430,
	"./girl 1.jpg": 80098,
	"./girl 5.jpg": 49478,
	"./girl birds.jpg": 64823,
	"./girl.jpg": 27279,
	"./honey bee 01.jpg": 53315,
	"./honey bee.jpg": 77916,
	"./ice-cream.jpg": 39853,
	"./lion 1.jpg": 62346,
	"./lion 2.jpg": 88597,
	"./mango 1-Recovered.jpg": 3014,
	"./pecock 1.jpg": 35761,
	"./psd mdl 6.jpg": 93251,
	"./rat 2.jpg": 82210,
	"./rat.jpg": 92104,
	"./smal tiger.jpg": 9443,
	"./tiger 01.jpg": 20855,
	"./tiger.jpg": 40184,
	"./vegetables 1.jpg": 70528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64507;